var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideoCircle = function SvgVideoCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/video-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.5002 7.07495C22.7736 7.07495 7.5752 22.2734 7.5752 41C7.5752 59.7266 22.7736 74.925 41.5002 74.925C60.2269 74.925 75.4253 59.7266 75.4253 41C75.4253 22.2734 60.2269 7.07495 41.5002 7.07495ZM50.5243 46.869L46.1819 49.3795L41.8395 51.8899C36.2419 55.1128 31.662 52.4667 31.662 46.0209V41V35.9791C31.662 29.4994 36.2419 26.8872 41.8395 30.1101L46.1819 32.6205L50.5243 35.131C56.1219 38.3538 56.1219 43.6462 50.5243 46.869Z",
    fill: "#E1DACF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideoCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video-circle.56338af2812199c1b0d3c7861067085e.svg";